// ©2024 Austin App House. All rights reserved.
import React from 'react';
import PropTypes from 'prop-types';

const DashboardModalShell = ({
  isOpen,
  onClose,
  title,
  titleId,
  className,
  bodyClassName,
  children,
  footer,
}) => {
  if (!isOpen) {
    return null;
  }

  return (
    <div
      className={`dashboard-modal dashboard-modal--open${className ? ` ${className}` : ''}`}
      role="presentation"
      onClick={onClose}
    >
      <div
        className="dashboard-modal-panel"
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="dashboard-modal-header">
          <div className="dashboard-modal-title" id={titleId}>
            {title}
          </div>
          <button
            type="button"
            className="dashboard-modal-close"
            aria-label="close"
            onClick={onClose}
          />
        </div>
        <div className={`dashboard-modal-body${bodyClassName ? ` ${bodyClassName}` : ''}`}>
          {children}
        </div>
        {footer ? (
          <div className="dashboard-modal-footer">
            {footer}
          </div>
        ) : null}
      </div>
    </div>
  );
};

DashboardModalShell.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  titleId: PropTypes.string.isRequired,
  className: PropTypes.string,
  bodyClassName: PropTypes.string,
  children: PropTypes.node,
  footer: PropTypes.node,
};

DashboardModalShell.defaultProps = {
  className: '',
  bodyClassName: '',
  children: null,
  footer: null,
};

export default DashboardModalShell;
